import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const OrdersForSuppliersSlice = createSlice({
    name: "ordersForSuppliers",
    initialState,
    reducers: {
        ordersForSuppliersRequest(state) {
            state.loading = true;
        },
        ordersForSuppliersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        ordersForSuppliersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    ordersForSuppliersRequest,
    ordersForSuppliersRequestSuccess,
    ordersForSuppliersRequestError,
} = OrdersForSuppliersSlice.actions;

export default OrdersForSuppliersSlice.reducer;
